import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';
import { CONTENT_SENSITIVITY } from 'src/data/generation';

const BG_COLOR_UNSAFE = '#DB0E00';
const BG_COLOR_SENSITIVE = '#FFC04E';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: theme.spacing(2),
    },
    boxGroupTitle: {},

    content: {
      gap: 0,
    },

    expandButton: {
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      justifyContent: 'left',
      width: 'fit-content',
      marginTop: theme.spacing(1),
    },

    externalLinkIcon: {
      fontSize: theme.typography.pxToRem(12),
      margin: theme.spacing(0.25),
    },

    externalLink: {
      color: COLORS.primary.default,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
    },

    hide: {
      display: 'none',
    },

    badge: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: 'capitalize',
      position: 'absolute',
      right: theme.spacing(3),
      top: theme.spacing(0),
      marginLeft: 'auto',

      [`&[data-sensitivity="${CONTENT_SENSITIVITY.unsafe}"]`]: {
        color: BG_COLOR_UNSAFE,
      },
      [`&[data-sensitivity="${CONTENT_SENSITIVITY.sensitive}"]`]: {
        color: BG_COLOR_SENSITIVE,
      },
      [`&[data-sensitivity="${CONTENT_SENSITIVITY.safe}"]`]: {
        color: theme.palette.secondary.main,
      },
    },

    reason: {
      paddingLeft: 0 + '!important',
    },

    collapseWrapperInner: {
      gap: 0 + '!important',
      paddingTop: theme.spacing(0),
      marginTop: theme.spacing(-2),
    },
  }),
  { name: 'ChannelPolicy' }
);
